"use client";

import type { CurrentMetrics } from "@/lib/types/financial-snapshot";

function fmtMoney(v: number | null, currency: string): string {
  if (v == null) return "-";
  const abs = Math.abs(v);
  if (abs >= 1e12) return `${currency}${(v / 1e12).toFixed(2)}T`;
  if (abs >= 1e9) return `${currency}${(v / 1e9).toFixed(2)}B`;
  if (abs >= 1e6) return `${currency}${(v / 1e6).toFixed(1)}M`;
  return `${currency}${v.toFixed(0)}`;
}

function fmtNum(v: number | null, digits = 2): string {
  return v == null ? "-" : v.toFixed(digits);
}

function fmtPct(v: number | null): string {
  return v == null ? "-" : `${(v * 100).toFixed(1)}%`;
}

interface Props {
  metrics: CurrentMetrics;
  currency: string;
}

export function MetricPillRow({ metrics, currency }: Props) {
  const cells: Array<{ label: string; value: string }> = [
    { label: "Price", value: fmtMoney(metrics.price, currency) },
    { label: "Market Cap", value: fmtMoney(metrics.marketCap, currency) },
    { label: "PE", value: fmtNum(metrics.pe) },
    { label: "P/B", value: fmtNum(metrics.pb) },
    { label: "ROE", value: fmtPct(metrics.roe) },
    { label: "D/E", value: fmtNum(metrics.debtToEquity) },
    { label: "FCF Yield", value: fmtPct(metrics.fcfYield) },
  ];

  return (
    <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-7 gap-3 mb-6">
      {cells.map((c) => (
        <div
          key={c.label}
          className="bg-surface-light/5 border border-surface-light/10 rounded-lg px-3 py-2"
        >
          <div className="text-[10px] uppercase tracking-wide text-muted-foreground">
            {c.label}
          </div>
          <div className="text-sm font-semibold font-tabular mt-0.5">{c.value}</div>
        </div>
      ))}
    </div>
  );
}
